import { NotificationTrigger } from "../models/notification.trigger";

import BaseService from "./_base.service";

const endpoint = "notifications/trigger";

const NotificationTriggerService = {
  ...BaseService<NotificationTrigger>({ endpoint }),
};

export default NotificationTriggerService;
